import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Box, Text } from "sprout-ui-primitives";
import { Button } from "../Button";
import AuthenticateProvider from "./AuthenticateProvider";
const StyledBox = styled(Box)`
  a + a {
    margin-top: 16px;
  }
`;
const StyledButton = styled(Button)`
  padding: 0;
`;
const StyledBox2 = styled(Box)`
  a {
    text-decoration: underline;
  }
`;
const Authenticate = (props)=>{
    const { variant , onCalloutClick  } = props;
    const isSignUp = variant === "signup";
    return /*#__PURE__*/ _jsxs(Box, {
        m: "auto",
        maxWidth: "344px",
        width: "100%",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                as: "h1",
                fontSize: "45px",
                mb: "72px",
                textAlign: "center",
                children: isSignUp ? "Join Sprout" : "Welcome back."
            }),
            /*#__PURE__*/ _jsxs(StyledBox, {
                children: [
                    /*#__PURE__*/ _jsx(AuthenticateProvider, {
                        provider: "Google",
                        variant: variant
                    }),
                    /*#__PURE__*/ _jsx(AuthenticateProvider, {
                        provider: "Facebook",
                        variant: variant
                    }),
                    /*#__PURE__*/ _jsx(AuthenticateProvider, {
                        provider: "Twitter",
                        variant: variant
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                as: "p",
                mt: 10,
                textAlign: "center",
                children: [
                    isSignUp ? "Already have an account? " : "No account? ",
                    /*#__PURE__*/ _jsx(StyledButton, {
                        "data-cy": isSignUp ? "Auth_LoginButton" : "Auth_CreateAccountButton",
                        onClick: onCalloutClick,
                        children: /*#__PURE__*/ _jsx(Text, {
                            as: "span",
                            fontWeight: "bold",
                            color: "blue.500",
                            children: isSignUp ? "Sign in" : "Create one"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(StyledBox2, {
                as: "p",
                mt: "72px",
                textAlign: "center",
                lineHeight: "25px",
                color: "black.60",
                children: [
                    "Click \u201CSign ",
                    isSignUp ? "Up" : "In",
                    "\u201D to agree to",
                    " ",
                    /*#__PURE__*/ _jsx(Link, {
                        to: "/terms",
                        children: "Sprout\u2019s Terms of Service"
                    }),
                    " and",
                    " ",
                    /*#__PURE__*/ _jsx(Link, {
                        to: "/privacy",
                        children: "Privacy Policy"
                    }),
                    "."
                ]
            })
        ]
    });
};
export default Authenticate;
